module.exports = "/static/assets/56ed3470ff2a975158e03fa7eb673886.gif";